import Contact from "@/components/page-modules/contact/components/Contact";
const ContactComponent = () => <Contact data-sentry-element="Contact" data-sentry-component="ContactComponent" data-sentry-source-file="index.tsx" />;
export default ContactComponent;